import {
  IActivityEngagement,
  IParamsGetActivityEngagement,
  IPayloadCreateActivityEngagement,
  IPayloadUpdateActivityEngagement,
  IResponseActivityEngagementList,
} from 'app/api/activityEngagement/model'
import { getToken } from 'app/service/storage/storage-service'
import { IResponseQueryList } from '../model/common'
import { useInfiniteQuery, useMutation, useQueryClient } from 'react-query'
import { ActivityEngagementKeys } from '../query-key/acEngagement'
import {
  requestDeleteActivityEngagement,
  requestGetActivityEngagement,
  requestPostCreateActivityEngagement,
  requestUpdateActivityEngagement,
} from 'app/api/activityEngagement'

/* eslint-disable @typescript-eslint/no-explicit-any */
export function useGetActivityEngagementList(
  params: IParamsGetActivityEngagement,
  enabled = true,
) {
  const token = getToken()
  return useInfiniteQuery<IResponseQueryList<IActivityEngagement[]>, undefined>(
    ActivityEngagementKeys.listActivityEngagement(params),
    async () => {
      try {
        const res: IResponseActivityEngagementList =
          await requestGetActivityEngagement(params)
        const data: IActivityEngagement[] = res?.data?.rows || []
        return {
          data,
          total: res?.data?.total ?? 0,
        }
      } catch (error: any) {
        return {
          data: [],
          total: 0,
        }
      }
    },
    {
      enabled: !!token && enabled,
    },
  )
}

export const useDeleteActivityEngagement = () => {
  const query = useQueryClient()
  return useMutation<unknown, unknown, number[], unknown>(
    async (body: number[]) => {
      await requestDeleteActivityEngagement(body)
    },
    {
      onSuccess: () => {
        query.invalidateQueries({
          queryKey: ActivityEngagementKeys.allActivityEngagements,
        })
      },
    },
  )
}

export const useUpdateActivityEngagement = () => {
  const query = useQueryClient()
  return useMutation<
    unknown,
    unknown,
    IPayloadUpdateActivityEngagement,
    unknown
  >(
    async (body: IPayloadUpdateActivityEngagement) => {
      await requestUpdateActivityEngagement(body)
    },
    {
      onSuccess: () => {
        query.invalidateQueries({
          queryKey: ActivityEngagementKeys.allActivityEngagements,
        })
      },
    },
  )
}

export const useCreateActivityEngagement = () => {
  const query = useQueryClient()
  return useMutation<
    unknown,
    unknown,
    IPayloadCreateActivityEngagement,
    unknown
  >(
    async (body: IPayloadCreateActivityEngagement) => {
      await requestPostCreateActivityEngagement(body)
    },
    {
      onSuccess: () => {
        query.invalidateQueries({
          queryKey: ActivityEngagementKeys.allActivityEngagements,
        })
      },
    },
  )
}
